import styled from 'styled-components';
import { colors } from '../../base/styled/variables.styled';
export const Container = styled.div `
  width: 100%;
  height: 100%;
  background-color: ${colors.neutral000};
`;
export const Fragment = styled.div `
  max-width: 1280px;
  margin: 0px auto;
  position: relative;
`;
//# sourceMappingURL=History.style.js.map